import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const AutomationCircleSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default AutomationCircleSVG;
